(function () {
  "use strict";

  var LB_DECIMALS = 2;

  function moneyFormatter(format) {
    var pattern = format && format.indexOf("{{") !== -1 ? format : "${{amount}}";

    function withCommas(value) {
      var parts = value.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }

    function withDots(value) {
      var parts = value.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return parts[0] + (parts[1] ? "," + parts[1] : "");
    }

    return function (cents) {
      var amount = Math.round(cents) / 100;
      return pattern.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_match, name) {
        switch (name) {
          case "amount_no_decimals":
            return withCommas(String(Math.round(amount)));
          case "amount_with_comma_separator":
            return withDots(amount.toFixed(2));
          case "amount_no_decimals_with_comma_separator":
            return withDots(String(Math.round(amount)));
          default:
            return withCommas(amount.toFixed(2));
        }
      });
    };
  }

  function trimNumber(value) {
    return String(parseFloat(value.toFixed(LB_DECIMALS)));
  }

  function init(root) {
    if (root.dataset.bulkOrderReady === "true") return;
    root.dataset.bulkOrderReady = "true";

    var money = moneyFormatter(root.dataset.moneyFormat);
    var cartUrl = root.dataset.cartUrl || "/cart";
    var addUrl = (root.dataset.cartAddUrl || "/cart/add") + ".js";
    var updateUrl = (root.dataset.cartUpdateUrl || "/cart/update") + ".js";
    var listEl = root.querySelector("[data-bulk-list]");
    var searchEl = root.querySelector("[data-bulk-search]");
    var emptyEl = root.querySelector("[data-empty]");
    var summaryListEl = root.querySelector("[data-summary-list]");
    var summaryEmptyEl = root.querySelector("[data-summary-empty]");
    var totalsEl = root.querySelector("[data-totals]");
    var totalItemsEl = root.querySelector("[data-total-items]");
    var totalWeightEl = root.querySelector("[data-total-weight]");
    var totalPriceEl = root.querySelector("[data-total-price]");
    var itemsTermEl = root.querySelector("[data-items-term]");
    var submitEl = root.querySelector("[data-submit]");
    var statusEl = root.querySelector("[data-status]");

    /* The shipping row, which stays hidden until there is a charge to put in it. */
    var shippingRowEl = root.querySelector("[data-shipping-row]");
    var shippingTermEl = root.querySelector("[data-shipping-term]");
    var shippingAmountEl = root.querySelector("[data-shipping-amount]");

    if (!listEl || !submitEl) return;

    var mode = "quantity";
    var WEIGHT_STEP_LB = parseFloat(root.dataset.weightStep) || 1;

    /*
     * MINIMUM ORDER GATE. 0 or missing means off.
     *
     * The weight rule is mode independent on purpose. `lineWeight` already returns pounds in
     * both modes (quantity x variant weight, or the pounds typed), so a buyer cannot get under
     * the minimum by switching the toggle.
     */
    var MIN_WEIGHT_LB = parseFloat(root.dataset.minWeight) || 0;
    var MIN_QUANTITY = parseInt(root.dataset.minQuantity, 10) || 0;
    var MIN_WEIGHT_MSG = root.dataset.minWeightMessage ||
      "Minimum order is [min] lb. You have [current] lb. Add [short] lb more to check out.";
    var MIN_QUANTITY_MSG = root.dataset.minQuantityMessage ||
      "Minimum order is [min] units. You have [current]. Add [short] more.";
    var minHintEl = root.querySelector("[data-min-order-hint]");

    function fillTemplate(text, min, current, short) {
      return String(text)
        .replace(/\[\s*min\s*\]/gi, trimNumber(min))
        .replace(/\[\s*current\s*\]/gi, trimNumber(current))
        .replace(/\[\s*short\s*\]/gi, trimNumber(short));
    }

    /* Hint text while the selection is under a minimum, "" once it passes. */
    function minimumShortfall(totalWeight, totalUnits) {
      if (MIN_WEIGHT_LB > 0 && totalWeight < MIN_WEIGHT_LB) {
        return fillTemplate(MIN_WEIGHT_MSG, MIN_WEIGHT_LB, totalWeight, MIN_WEIGHT_LB - totalWeight);
      }
      /* Unit count only means something in quantity mode: a weight row is pinned to one unit. */
      if (MIN_QUANTITY > 0 && mode !== "weight" && totalUnits < MIN_QUANTITY) {
        return fillTemplate(MIN_QUANTITY_MSG, MIN_QUANTITY, totalUnits, MIN_QUANTITY - totalUnits);
      }
      return "";
    }

    /*
     * The shipping rate table, written by the app and read here.
     *
     * Three things all mean "no charge": no table, a table this browser cannot parse, and a
     * table that does not list this buyer's category. Shipping is money, so anything short of
     * a complete answer produces nothing rather than a guess.
     */
    var shippingTable = null;
    try {
      var shippingRaw = root.dataset.shippingRates;
      if (shippingRaw) {
        var shippingParsed = JSON.parse(shippingRaw);
        var shippingCategory = root.dataset.shippingCategory || "";
        var chargedCategories = (shippingParsed && shippingParsed.categories) || [];
        if (shippingCategory && chargedCategories.indexOf(shippingCategory) !== -1) {
          shippingTable = shippingParsed;
        }
      }
    } catch (e) {
      shippingTable = null;
    }

    /*
     * HOW SHIPPING IS CHARGED. Chosen on the app's Shipping rates tab and saved in the same
     * rate table, so this page and the Cart Transform always read the same answer:
     *
     *   'product'  (default)  a Delivery charge line is added to the cart
     *   'included'            no extra line; the Cart Transform spreads the charge across the
     *                         lobster prices and checkout shows free shipping
     *
     * A table saved before the choice existed has no mode, and reads as 'product' — what was
     * live before.
     */
    var shippingIncluded = !!(shippingTable && shippingTable.shippingMode === "included");

    var labels = {
      quantity: root.dataset.quantityLabel || "ea",
      weight: root.dataset.weightLabel || "lb",
      quantitySuffix: root.dataset.quantitySuffix || "ea",
      weightSuffix: root.dataset.weightSuffix || "lb",
      pieceSuffix: root.dataset.pieceSuffix || "pc",
      shipping: root.dataset.shippingLabel || "Shipping",
      shippingIncluded: root.dataset.shippingIncludedLabel || "Shipping (included)",
      addButton: root.dataset.addButtonLabel || "Add to cart",
      addSelected: root.dataset.addSelectedLabel || "Add [count] to cart",
      adding: root.dataset.addingMessage || "Adding to cart…",
      added: root.dataset.addedMessage || "Added to cart.",
      error: root.dataset.errorMessage || "Could not add to cart. Please try again.",
      unavailable: root.dataset.unavailableLabel || "Unavailable",
      noWeight: root.dataset.noWeightLabel || "No weight recorded, order by quantity",
      items: (itemsTermEl && itemsTermEl.textContent.trim()) || "Items",
      products: root.dataset.productsLabel || "Products"
    };

    var rows = Array.prototype.map.call(listEl.querySelectorAll("[data-row]"), function (el) {
      var priceEl = el.querySelector(".bulkorder__row-price");
      return {
        el: el,
        field: el.querySelector("[data-field]"),
        unitEl: el.querySelector("[data-unit]"),
        priceEl: priceEl,
        qtyPriceHtml: priceEl ? priceEl.innerHTML : "",
        variantId: el.dataset.variantId,
        name: el.dataset.name || "",
        search: el.dataset.search || "",
        priceCents: parseInt(el.dataset.price, 10) || 0,
        rateCents: parseInt(el.dataset.ratePerLb, 10) || 0,
        weightLb: parseFloat(el.dataset.weightLb) || 0,
        minQty: parseInt(el.dataset.minQty, 10) || 1,
        qty: 0,
        lbs: 0,
        inputLabel: null,
        minusButton: null,
        plusButton: null,
        editing: false
      };
    });

    /* The lowest weight a selected row may hold: one piece, rounded to the displayed
       precision. 0 means the row has no recorded weight, so no floor applies. */
    function weightFloor(row) {
      return row.weightLb > 0 ? parseFloat(row.weightLb.toFixed(LB_DECIMALS)) : 0;
    }

    function ratePerLbCents(row) {
      if (row.rateCents > 0) return row.rateCents;
      if (!(row.weightLb > 0) || !(row.priceCents > 0)) return 0;
      return row.priceCents / row.weightLb;
    }

    function sellable(row) {
      if (row.field && row.field.disabled) return false;
      return mode === "weight" ? ratePerLbCents(row) > 0 : true;
    }

    function amountOf(row) {
      return mode === "weight" ? row.lbs : row.qty;
    }

    function setAmount(row, value) {
      if (mode === "weight") {
        /* A selected row cannot sit below one piece: a positive value under the floor
           snaps up to it. 0 stays 0 so the row can still be left unselected. */
        var floor = weightFloor(row);
        if (value > 0 && floor > 0 && value < floor) {
          value = floor;
        }
        row.lbs = value > 0 ? value : 0;
        /* Editing the weight makes the stored quantity stale, so clear it. On a later
           switch to quantity it is recomputed from this weight. This is what stops a
           zeroed value in one mode from re-appearing in the other. */
        row.qty = 0;
      } else {
        row.qty = value > 0 ? Math.round(value) : 0;
        /* Same the other way: editing the quantity makes the stored weight stale. */
        row.lbs = 0;
      }
    }

    function lineCents(row) {
      return mode === "weight" ? row.lbs * ratePerLbCents(row) : row.qty * row.priceCents;
    }

    function lineWeight(row) {
      return mode === "weight" ? row.lbs : row.qty * row.weightLb;
    }

    /* ----------------------------------------------------------------------
     * Shipping
     *
     * MIRRORS lib/shipping.js IN THE APP. What is shown here is an estimate so the buyer
     * sees the cost before checkout; the Cart Transform recomputes it server-side before
     * anything is actually charged. If one side changes, change the other.
     * -------------------------------------------------------------------- */

    function zoneForZip(zip) {
      var prefix = parseInt(String(zip || "").trim().slice(0, 3), 10);
      if (!isFinite(prefix)) return null;

      var ranges = (shippingTable && shippingTable.zipRanges) || [];
      for (var i = 0; i < ranges.length; i += 1) {
        if (prefix >= ranges[i][0] && prefix <= ranges[i][1]) return ranges[i][2];
      }
      return null;
    }

    /* Rounds UP, the way FedEx bills: 19.5 lb is charged as 20 lb. */
    function bandForWeight(lbs) {
      var bands = (shippingTable && shippingTable.bands) || [];
      for (var i = 0; i < bands.length; i += 1) {
        if (lbs <= bands[i]) return bands[i];
      }
      return null;
    }

    /*
     * FedEx rates one box at a time and will not take more than 150 lb in one, so a large
     * order ships as several and each is priced separately. A 500 lb order in 50 lb coolers
     * costs ten times the 50 lb rate — there is no 500 lb rate to look up.
     */
    function shippingFor(lbs) {
      if (!shippingTable || !(lbs > 0)) return null;

      var zone = zoneForZip(root.dataset.shippingZip);
      if (zone === null) return null;

      var zoneIndex = (shippingTable.zones || []).indexOf(zone);
      if (zoneIndex < 0) return null;

      var perBox = Math.min(shippingTable.maxPerBoxLb || 0, 150);
      if (!(perBox > 0)) return null;

      /* Equal weights, the way a packing bench works — not nine full boxes and one nearly
         empty. The band is the same for every box, so one lookup covers all of them. */
      var count = Math.ceil(lbs / perBox);
      var band = bandForWeight(lbs / count);
      if (band === null) return null;

      var row = (shippingTable.rates || {})[band];
      var price = row ? row[zoneIndex] : null;
      if (price === null || price === undefined) return null;

      return { cents: Math.round(price * 100) * count, boxes: count };
    }

    function setStatus(message, kind) {
      if (!statusEl) return;
      statusEl.textContent = message || "";
      statusEl.className = "bulkorder__status" + (kind ? " is-" + kind : "");
    }

    function fieldValueFor(row) {
      var amount = amountOf(row);
      if (!(amount > 0)) return "";
      return mode === "weight" ? trimNumber(amount) : String(amount);
    }

    /* Under the product title: "$27.00 /per pc" by quantity, "$12.00 /per lb" by weight. Weight range always stays visible. */
    function updateRowPrice(row) {
      if (!row.priceEl) return;
      var rate = ratePerLbCents(row);

      if (mode === "weight" && rate > 0) {
        row.priceEl.textContent = money(rate) + " /per " + labels.weightSuffix + " ";
      } else if (row.priceCents > 0) {
        row.priceEl.textContent = money(row.priceCents) + " /per " + labels.pieceSuffix + " ";
      } else {
        row.priceEl.innerHTML = row.qtyPriceHtml;
      }
    }

    function syncRowField(row) {
      if (!row.field) return;

      var byWeight = mode === "weight";
      var usable = sellable(row);

      if (!(byWeight && row.editing)) {
        row.field.value = fieldValueFor(row);
      }

      row.field.step = byWeight ? "0.01" : "1";
      /* In weight mode the minimum is one piece; in quantity mode it is 0 as before. */
      row.field.min = byWeight && weightFloor(row) > 0 ? String(weightFloor(row)) : "0";
      row.field.inputMode = byWeight ? "decimal" : "numeric";

      if (byWeight && !usable && row.field.dataset.hardDisabled !== "true") {
        row.field.disabled = true;
      } else if (row.field.dataset.hardDisabled !== "true") {
        row.field.disabled = false;
      }

      if (row.inputLabel) {
        row.inputLabel.textContent = byWeight ? "Weight" : "QTY";
      }

      if (row.unitEl) {
        row.unitEl.textContent = byWeight ? labels.weightSuffix : labels.quantitySuffix;
      }

      if (row.minusButton) {
        row.minusButton.disabled = row.field.disabled || !(amountOf(row) > 0);
        row.minusButton.setAttribute("aria-label", byWeight ? "Decrease weight" : "Decrease quantity");
      }

      if (row.plusButton) {
        row.plusButton.disabled = row.field.disabled;
        row.plusButton.setAttribute("aria-label", byWeight ? "Increase weight" : "Increase quantity");
      }

      updateRowPrice(row);
    }

    function step(row, direction) {
      if (row.field.disabled) return;
      var by = mode === "weight" ? WEIGHT_STEP_LB : 1;
      var next = amountOf(row) + direction * by;
      if (next < 0) next = 0;

      /* Keep the stepper on the right side of the one-piece floor: stepping down out of
         range removes the row (0), stepping up into range lands on one piece. */
      if (mode === "weight") {
        var floor = weightFloor(row);
        if (floor > 0 && next > 0 && next < floor) {
          next = direction < 0 ? 0 : floor;
        }
      }

      setAmount(row, next);
      row.editing = false;
      setStatus("");
      syncRowField(row);
      render();
    }

    /* Build or reuse the label and +/- stepper controls for each row */
    rows.forEach(function (row) {
      if (!row.field) return;

      if (row.field.disabled) {
        row.field.dataset.hardDisabled = "true";
      }

      var container = row.field.parentElement;
      if (!container) return;

      var existingLabel = row.el.querySelector("[data-input-label]");
      var existingMinus = row.el.querySelector("[data-minus]");
      var existingPlus = row.el.querySelector("[data-plus]");

      if (existingLabel && existingMinus && existingPlus) {
        row.inputLabel = existingLabel;
        row.minusButton = existingMinus;
        row.plusButton = existingPlus;
      } else {
        var label = document.createElement("span");
        label.className = "bulkorder__input-label";
        label.dataset.inputLabel = "";
        label.textContent = "QTY";

        var controls = document.createElement("div");
        controls.className = "bulkorder__field-controls";

        var minus = document.createElement("button");
        minus.type = "button";
        minus.className = "bulkorder__stepper bulkorder__stepper--minus";
        minus.dataset.minus = "";
        minus.setAttribute("aria-label", "Decrease quantity");
        minus.textContent = "−";

        var plus = document.createElement("button");
        plus.type = "button";
        plus.className = "bulkorder__stepper bulkorder__stepper--plus";
        plus.dataset.plus = "";
        plus.setAttribute("aria-label", "Increase quantity");
        plus.textContent = "+";

        container.insertBefore(label, row.field);
        container.insertBefore(controls, row.field);
        controls.appendChild(minus);
        controls.appendChild(row.field);
        controls.appendChild(plus);

        row.inputLabel = label;
        row.minusButton = minus;
        row.plusButton = plus;
      }

      row.plusButton.addEventListener("click", function () {
        step(row, 1);
      });
      row.minusButton.addEventListener("click", function () {
        step(row, -1);
      });
    });

    function applyMode() {
      root.dataset.mode = mode;

      Array.prototype.forEach.call(root.querySelectorAll("[data-set-mode]"), function (button) {
        button.classList.toggle("is-active", button.dataset.setMode === mode);
      });

      if (itemsTermEl) {
        itemsTermEl.textContent = mode === "weight" ? labels.products : labels.items;
      }

      rows.forEach(function (row) {
        /* Fill the newly active mode from the other only when it is empty (stale after an
           edit). An untouched value is left as-is, so switching back and forth without
           editing never drifts. */
        if (mode === "weight") {
          if (!(row.lbs > 0) && row.qty > 0 && row.weightLb > 0) {
            row.lbs = parseFloat((row.qty * row.weightLb).toFixed(LB_DECIMALS));
          }
        } else if (!(row.qty > 0) && row.lbs > 0 && row.weightLb > 0) {
          row.qty = Math.max(1, Math.round(row.lbs / row.weightLb));
        }
        row.editing = false;
        syncRowField(row);
      });

      setStatus("");
      render();
    }

    function updateSubmitButton(count, any, blocked) {
      if (!submitEl) return;

      if (!any) {
        submitEl.textContent = labels.addButton;
        submitEl.disabled = true;
        return;
      }

      var template = labels.addSelected || "Add [count] to cart";
      var hasPlaceholder = /\[\s*count\s*\]|\{\{?\s*count\s*\}?\}/i.test(template);

      submitEl.textContent = hasPlaceholder
        ? template
            .replace(/\[\s*count\s*\]/gi, String(count))
            .replace(/\{\{\s*count\s*\}\}/gi, String(count))
            .replace(/\{\s*count\s*\}/gi, String(count))
        : "Add " + count + " to cart";
      submitEl.disabled = !!blocked;
    }

    function render() {
      var selected = rows.filter(function (row) {
        return amountOf(row) > 0 && sellable(row);
      });
      var totalWeight = 0;
      var totalCents = 0;
      var totalItems = 0;

      rows.forEach(function (row) {
        row.el.classList.toggle("is-selected", amountOf(row) > 0);
        syncRowField(row);
      });

      if (summaryListEl) summaryListEl.textContent = "";

      selected.forEach(function (row) {
        totalWeight += lineWeight(row);
        totalCents += lineCents(row);
        totalItems += mode === "weight" ? 1 : row.qty;

        if (!summaryListEl) return;

        var item = document.createElement("li");
        item.className = "bulkorder__summary-item";

        var left = document.createElement("span");
        left.className = "bulkorder__summary-item-name";

        var name = document.createElement("span");
        name.textContent = row.name;
        left.appendChild(name);

        var detail = document.createElement("span");
        detail.className = "bulkorder__summary-item-qty";
        if (mode === "weight") {
          detail.textContent =
            trimNumber(row.lbs) + " " + labels.weightSuffix + " × " +
            money(ratePerLbCents(row)) + "/" + labels.weightSuffix;
        } else {
          detail.textContent =
            row.qty + " × " + money(row.priceCents) +
            (row.weightLb > 0
              ? " · " + (row.qty * row.weightLb).toFixed(LB_DECIMALS) + " " + labels.weightSuffix
              : "");
        }
        left.appendChild(detail);

        var price = document.createElement("span");
        price.className = "bulkorder__summary-item-price";
        price.textContent = money(lineCents(row));

        item.appendChild(left);
        item.appendChild(price);
        summaryListEl.appendChild(item);
      });

      var any = selected.length > 0;

      if (summaryEmptyEl) summaryEmptyEl.hidden = any;
      if (totalsEl) totalsEl.hidden = !any;
      if (totalItemsEl) totalItemsEl.textContent = String(totalItems);
      if (totalWeightEl) totalWeightEl.textContent = totalWeight.toFixed(LB_DECIMALS) + " " + labels.weightSuffix;

      /*
       * Shipping is shown on its own row and added to the TOTAL, in both modes. The per-lb
       * figures beside each product stay the catalog prices the buyer was quoted, so the
       * buyer can see what the delivered total is made of.
       *
       * In 'included' mode the cart puts this same amount inside the lobster prices instead
       * of on a Delivery charge line, so the row is labelled as included. The total is the
       * same either way.
       */
      var shipping = any ? shippingFor(totalWeight) : null;

      if (shippingRowEl) {
        shippingRowEl.hidden = !shipping;
        if (shipping) {
          if (shippingTermEl) {
            shippingTermEl.textContent =
              (shippingIncluded ? labels.shippingIncluded : labels.shipping) +
              (shipping.boxes > 1 ? " — " + shipping.boxes + " boxes" : "");
          }
          if (shippingAmountEl) shippingAmountEl.textContent = money(shipping.cents);
        }
      }

      if (totalPriceEl) {
        totalPriceEl.textContent = money((any ? totalCents : 0) + (shipping ? shipping.cents : 0));
      }

      var shortfall = any ? minimumShortfall(totalWeight, totalItems) : "";

      if (minHintEl) {
        minHintEl.textContent = shortfall;
        minHintEl.hidden = shortfall === "";
      }

      updateSubmitButton(totalItems, any, shortfall !== "");
      announce(selected.length, shortfall);
      saveSnapshot();
    }

    /* Lets bulk-order-checkout.js know what is selected, without reaching into this closure. */
    function announce(count, shortfall) {
      var detail = { count: count, shortfall: shortfall || "" };
      var event;
      try {
        event = new CustomEvent("bulkorder:change", { detail: detail });
      } catch (e) {
        event = document.createEvent("CustomEvent");
        event.initCustomEvent("bulkorder:change", false, false, detail);
      }
      root.dispatchEvent(event);
    }

    if (searchEl) {
      searchEl.addEventListener("input", function () {
        var term = searchEl.value.trim().toLowerCase();
        var visible = 0;

        rows.forEach(function (row) {
          var match = term === "" || amountOf(row) > 0 || row.search.indexOf(term) !== -1;
          row.el.classList.toggle("is-hidden", !match);
          if (match) visible += 1;
        });

        if (emptyEl) emptyEl.hidden = visible > 0;
      });
    }

    function rowFor(field) {
      for (var i = 0; i < rows.length; i += 1) {
        if (rows[i].field === field) return rows[i];
      }
      return null;
    }

    function commitField(row, field) {
      var raw = parseFloat(field.value);
      setAmount(row, isFinite(raw) && raw > 0 ? raw : 0);
      row.editing = false;
    }

    listEl.addEventListener("input", function (event) {
      var field = event.target.closest && event.target.closest("[data-field]");
      if (!field) return;
      var row = rowFor(field);
      if (!row) return;

      setStatus("");
      var raw = parseFloat(field.value);
      setAmount(row, isFinite(raw) && raw > 0 ? raw : 0);
      row.editing = mode === "weight";
      render();
    });

    listEl.addEventListener("blur", function (event) {
      var field = event.target.closest && event.target.closest("[data-field]");
      if (!field) return;
      var row = rowFor(field);
      if (!row) return;

      commitField(row, field);
      syncRowField(row);
      render();
    }, true);

    listEl.addEventListener("keydown", function (event) {
      if (event.key !== "Enter") return;
      var field = event.target.closest && event.target.closest("[data-field]");
      if (!field) return;
      var row = rowFor(field);
      if (!row) return;

      event.preventDefault();
      commitField(row, field);
      syncRowField(row);
      render();
    });

    Array.prototype.forEach.call(root.querySelectorAll("[data-set-mode]"), function (button) {
      button.addEventListener("click", function () {
        var next = button.dataset.setMode;
        if (!next || next === mode) return;
        mode = next;
        applyMode();
      });
    });

    function itemsPayload() {
      var items = rows
        .filter(function (row) {
          return amountOf(row) > 0 && sellable(row);
        })
        .map(function (row) {
          if (mode !== "weight") {
            return { id: Number(row.variantId), quantity: row.qty };
          }
          return {
            id: Number(row.variantId),
            quantity: row.minQty > 0 ? row.minQty : 1,
            properties: {
              "Ordering method": "By weight",
              "Weight requested": trimNumber(row.lbs) + " lb",
              "_Rate per lb": String(Math.round(ratePerLbCents(row)))
            }
          };
        });

      /*
       * The shipping charge rides along as its own line — in 'product' mode only.
       *
       * Shopify has nowhere else to put money — a cart holds line items and shipping rates,
       * and nothing can write to the shipping row except a rate. So the charge is a line.
       *
       * In 'included' mode no line is added: the Cart Transform puts the charge inside the
       * lobster prices instead.
       *
       * The AMOUNT is not sent. `_Delivery charge` only marks which line it is; the Cart
       * Transform works the price out server-side from the same table, because a price that
       * travelled through a browser is a price a customer could edit.
       */
      var shippingVariant = Number(root.dataset.shippingVariant);
      var shipping = items.length ? shippingFor(totalSelectedWeight()) : null;

      if (shipping && shippingVariant > 0 && !shippingIncluded) {
        items.push({
          id: shippingVariant,
          quantity: 1,
          properties: {
            "_Delivery charge": "yes",
            /* For the order and the packing bench, not for pricing. */
            "Shipping": shipping.boxes + (shipping.boxes === 1 ? " box" : " boxes")
          }
        });
      }

      return items;
    }

    /**
     * Removes the shipping line from the cart, if one is there.
     *
     * CALLED BEFORE EVERY ADD, and that is the whole fix. The shipping charge is a line item,
     * and adding items a second time used to add a SECOND one: leave checkout without paying,
     * come back, add one more box, and the cart carried two delivery charges. Only the first
     * is priced by the Cart Transform, so the second sat there at its catalog price and the
     * total was wrong by exactly that much.
     *
     * Zeroing the VARIANT rather than a line index removes every copy in one request, so a
     * cart that already went wrong is repaired by the next add rather than kept wrong. It also
     * does not care where in the cart the line sits, which a line index would.
     *
     * Runs in BOTH modes. In 'included' mode it is what clears a Delivery charge line left in
     * a cart from before the switch.
     *
     * Not swallowed on failure. If the old line cannot be removed then adding a new one
     * duplicates the charge, so the add must not happen — better a visible error than a
     * silently inflated total.
     */
    function dropShippingLine() {
      var shippingVariant = Number(root.dataset.shippingVariant);
      if (!(shippingVariant > 0)) return Promise.resolve();

      var updates = {};
      updates[shippingVariant] = 0;

      return fetch(updateUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ updates: updates })
      }).then(function (response) {
        if (!response.ok) throw new Error(labels.error);
        return response.json();
      });
    }

    /** The weight every selected row adds up to, in the current mode. */
    function totalSelectedWeight() {
      return rows.reduce(function (sum, row) {
        return sum + (amountOf(row) > 0 && sellable(row) ? lineWeight(row) : 0);
      }, 0);
    }

    /* ------------------------------------------------------------------
     * DELIVERY CHARGE REQUIREMENT STAMP
     *
     * The cart page and the drawer cannot read this section's settings, so the requirement
     * has to travel with the cart. lb-cart-gate.liquid reads these back, locks the charge
     * line's controls, and restores the line if a buyer removes it on the way back from an
     * abandoned checkout.
     *
     * Cleared, not just set, when nothing is owed. A cart that stopped qualifying must not
     * keep demanding a charge it no longer needs.
     *
     * NEVER REQUIRED IN 'included' MODE. There is no Delivery charge line to lock or restore:
     * the charge is already inside the lobster prices. Stamping it would make the cart gate
     * put a line back, and the buyer would pay shipping twice. Clearing it also releases a
     * cart stamped before the switch.
     * ------------------------------------------------------------------ */
    function markShippingRequirement(shipping) {
      var shippingVariant = Number(root.dataset.shippingVariant);
      var required = !!(shipping && shippingVariant > 0 && !shippingIncluded);

      return fetch(updateUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          attributes: {
            "_Delivery charge required": required ? "yes" : "",
            "_Delivery charge variant": required ? String(shippingVariant) : ""
          }
        })
      }).catch(function () {
        /* Best effort. A failed stamp must not stop an otherwise good add. */
      });
    }

    /* ------------------------------------------------------------------
     * RETURN FROM CHECKOUT
     *
     * Four behaviours, set per section so each can be tested on its own:
     *
     *   current        leave everything alone; a reload clears the page as it always has
     *   clear_cart     empty the cart, page starts blank
     *   restore_page   refill the page and empty the cart, so the order lives in one place
     *   restore_both   refill the page AND keep the cart, so the buyer can edit and re-add
     *
     * None of these fire on an ordinary reload. They need the load to FOLLOW a checkout.
     * ------------------------------------------------------------------ */
    var RETURN_BEHAVIOUR = root.dataset.returnBehaviour || "current";
    var SNAPSHOT_KEY = "lbBulkOrderSelection";
    var LEFT_KEY = "lbBulkOrderLeftForCheckout";

    function storage() {
      try {
        return window.sessionStorage;
      } catch (e) {
        return null;
      }
    }

    function saveSnapshot() {
      if (RETURN_BEHAVIOUR === "current") return;
      var store = storage();
      if (!store) return;

      var items = {};
      rows.forEach(function (row) {
        var amount = amountOf(row);
        if (amount > 0) items[row.variantId] = amount;
      });

      try {
        store.setItem(SNAPSHOT_KEY, JSON.stringify({ mode: mode, items: items }));
      } catch (e) {}
    }

    function readSnapshot() {
      var store = storage();
      if (!store) return null;
      try {
        return JSON.parse(store.getItem(SNAPSHOT_KEY) || "null");
      } catch (e) {
        return null;
      }
    }

    /*
     * Did this page load follow a trip to checkout?
     *
     * The referrer covers every route in, whichever surface the buyer checked out from. The
     * session flag is the fallback for the cases where it is stripped: the back button
     * restoring from bfcache, and some in-app browsers.
     */
    function cameFromCheckout() {
      var ref = document.referrer || "";
      if (ref.indexOf("/checkouts/") !== -1 || ref.indexOf("/checkout") !== -1) return true;

      var store = storage();
      if (!store) return false;
      try {
        return store.getItem(LEFT_KEY) === "1";
      } catch (e) {
        return false;
      }
    }

    function clearReturnMarker() {
      var store = storage();
      if (!store) return;
      try {
        store.removeItem(LEFT_KEY);
      } catch (e) {}
    }

    function clearCart() {
      return fetch("/cart/clear.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" }
      })
        .then(function () {
          /* Keep the header count and the drawer honest after emptying it. */
          var ajaxCart = window.PXUTheme && window.PXUTheme.jsAjaxCart;
          if (ajaxCart && typeof ajaxCart.updateView === "function") ajaxCart.updateView();
        })
        .catch(function () {});
    }

    function applySnapshot(snapshot) {
      if (!snapshot || !snapshot.items) return;
      if (snapshot.mode === "weight" || snapshot.mode === "quantity") mode = snapshot.mode;

      rows.forEach(function (row) {
        var amount = snapshot.items[row.variantId];
        if (!(amount > 0)) return;
        if (mode === "weight") {
          row.lbs = parseFloat(amount);
        } else {
          row.qty = parseInt(amount, 10);
        }
      });
    }

    function applyReturnBehaviour() {
      if (RETURN_BEHAVIOUR === "current") return;
      if (!cameFromCheckout()) return;
      clearReturnMarker();

      if (RETURN_BEHAVIOUR === "clear_cart") {
        clearCart();
      } else if (RETURN_BEHAVIOUR === "restore_page") {
        applySnapshot(readSnapshot());
        clearCart();
      } else if (RETURN_BEHAVIOUR === "restore_both") {
        applySnapshot(readSnapshot());
      }
    }

    submitEl.addEventListener("click", function () {
      var items = itemsPayload();
      if (items.length === 0) return;

      /* Captured before the rows are cleared on success, or the stamp would read zero. */
      var owedShipping = shippingFor(totalSelectedWeight());

      submitEl.disabled = true;
      submitEl.classList.add("is-busy");
      setStatus(labels.adding);

      /* Old shipping line out before the new one goes in, or the cart ends up with both. */
      dropShippingLine()
        .then(function () {
          return fetch(addUrl, {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (response) {
          return response.json().then(function (body) {
            return { ok: response.ok, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            var description = (result.body && (result.body.description || result.body.message)) || "";
            throw new Error(description || labels.error);
          }

          setStatus(labels.added, "ok");
          markShippingRequirement(owedShipping);
          rows.forEach(function (row) {
            row.qty = 0;
            row.lbs = 0;
            row.editing = false;
          });
          render();
          submitEl.classList.remove("is-busy");

          var ajaxCart = window.PXUTheme && window.PXUTheme.jsAjaxCart;
          if (ajaxCart && ajaxCart.cart_action === "drawer" && typeof ajaxCart.showDrawer === "function") {
            if (typeof ajaxCart.updateView === "function") ajaxCart.updateView();
            ajaxCart.showDrawer();
          } else {
            window.location.href = cartUrl;
          }
        })
        .catch(function (error) {
          setStatus(error.message || labels.error, "error");
          submitEl.classList.remove("is-busy");
          render();
        });
    });

    /* Public API for the direct checkout button (bulk-order-checkout.js). */
    root.bulkOrderApi = {
      items: itemsPayload,
      /* The direct-checkout button adds items by itself, so it needs the same cleanup. */
      dropShippingLine: dropShippingLine,
      /* ...and the same requirement stamp, so the cart gate works on both paths. */
      markShippingRequirement: markShippingRequirement,
      count: function () {
        return rows.filter(function (row) {
          return amountOf(row) > 0 && sellable(row);
        }).length;
      },
      clear: function () {
        rows.forEach(function (row) {
          row.qty = 0;
          row.lbs = 0;
          row.editing = false;
        });
        render();
      },
      /* The current shipping estimate, so the checkout script can show the same figure
         without recomputing it. Null when this tier is not charged. */
      shipping: function () {
        return shippingFor(totalSelectedWeight());
      },
      /* True when shipping is inside the lobster prices rather than on its own line. */
      shippingIncluded: function () {
        return shippingIncluded;
      }
    };

    window.bulkOrderDebug = function () {
      var report = rows
        .filter(function (row) {
          return amountOf(row) > 0;
        })
        .map(function (row) {
          return {
            name: row.name,
            mode: mode,
            "unit lb": row.weightLb ? row.weightLb.toFixed(3) : null,
            "rate per lb": money(ratePerLbCents(row)),
            qty: row.qty,
            lbs: row.lbs,
            "cart quantity": mode === "weight" ? row.minQty || 1 : row.qty,
            "line total": money(lineCents(row))
          };
        });
      console.table(report);
      console.log(
        "shipping:",
        root.bulkOrderApi.shipping(),
        shippingIncluded ? "(included in prices)" : "(Delivery charge line)"
      );
      return report;
    };

    applyReturnBehaviour();
    applyMode();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-bulk-order]"), init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();